module.exports = __webpack_public_path__ + "assets-customer/images/mens-category.png?612233b3";